<app-kontable
  [service]="srvPromotionSystem"
  [paginationType]="paginationType"
  [title]="'promotionSystemList.listTitle' | translate"
  [columns]="[{field: 'img_url', title: '', searchable: false, sortable: false, bodyTemplate: imgTemplate}, 'id', 'code', 'name', 'description', {field: 'flg_state', title: 'common.status', bodyTemplate: statusTemplate, filterType: selectFilter, filterOptions: {values: stateFilterOptions}}]"
  [titles]="['common.id', 'common.code', 'common.name', 'common.description']"
  [showInfoButton]="false"
  [showRecoverButton]="false"
  [showDetailsButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [showAddButton]="true"
  [showReport]="false"
  [additionalRowCommands]="rowActionsTemplate"
  (onAdd)="showAddOrEditDialog(null)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="deleteItem($event)"
  [(fireNewDataAvailable)]="newDataAvailable"
>
  <ng-template #rowActionsTemplate let-row>
    <button pButton type="button" icon="fa fa-pencil" class="ui-button-success"
      *ngIf="row.flg_state == 0"
      pTooltip="{{ 'common.edit' | translate }}" tooltipPosition="top"
      (click)="showAddOrEditDialog(row)"></button>
    <button pButton type="button" icon="fa fa-trash" class="ui-button-danger"
      *ngIf="row.flg_state == 0"
      pTooltip="{{ 'common.delete' | translate }}" tooltipPosition="top"
      (click)="confirmDelete(row)"></button>
    <button pButton type="button" icon="fa fas fa-undo" class="ui-button-info"
      *ngIf="row.flg_state == 1"
      pTooltip="{{ 'common.undo' | translate }}" tooltipPosition="top"
      (click)="recoverItem(row)"></button>
  </ng-template>
  <ng-template #imgTemplate let-row>
    <img *ngIf="row.img_url || row.img_b64; else noImg" [src]="row.img_url || row.img_b64" class="list-img-preview" alt="">
    <ng-template #noImg>
      <div class="list-img-placeholder"><i class="fa fa-image"></i></div>
    </ng-template>
  </ng-template>
  <ng-template #statusTemplate let-row>
    <div class="status-badge-table" [ngClass]="row.flg_state == 0 ? 'badge-active' : 'badge-inactive'">
      <span class="status-dot" [ngClass]="row.flg_state == 0 ? 'dot-active' : 'dot-inactive'"></span>
      {{ (row.flg_state == 0 ? 'status.active' : 'status.inactive') | translate }}
    </div>
  </ng-template>
</app-kontable>



// WEBPACK FOOTER //
// ./src/app/views/administration/promotion-system/promotion-system.component.html